import request from './request'


// 子账号列表
export function subGetList(params) {
  return request({
    url: '/subaccount/list',
    method: 'get',
    params
  })
}

// 角色列表
export function roleGetList() {
  return request({
    url: '/role/list',
    method: 'get'
  })
}

// 权限列表
export function permissionGetList(params) {
  return request({
    url: '/permission/list',
    method: 'get',
    params
  })
}

// 子账号创建
export function subCreate(data) {
  return request({
    url: '/subaccount/create',
    method: 'post',
    data
  })
}

// 子账号编辑
export function subUpdate(id, data) {
  return request({
    url: '/subaccount/update/' + id,
    method: 'put',
    data
  })
}

// 子账号删除
export function subDelete(id) {
  return request({
    url: '/subaccount/delete/' + id,
    method: 'delete'
  })
}

// 所有账号列表
export function allSubGetList(params) {
  return request({
    url: '/subaccount/list-all',
    method: 'get',
    params
  })
}
